import React, { useState } from 'react';
import { useEditMode } from '../contexts/EditModeContext';

function SectionManager({ sections, onChange }) {
  const { isEditMode } = useEditMode();
  const [isExpanded, setIsExpanded] = useState(false);

  const moveSection = (index, direction) => {
    const updated = [...sections];
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    if (newIndex < 0 || newIndex >= updated.length) return;
    [updated[index], updated[newIndex]] = [updated[newIndex], updated[index]];
    onChange(updated);
  };

  const addSection = () => {
    const newSection = {
      id: `section-${Date.now()}`,
      title: 'New Section',
      type: 'generic',
      content: [{ type: 'text', value: 'Add your content here' }]
    };
    onChange([...sections, newSection]);
  };

  const removeSection = (index) => {
    if (window.confirm('Are you sure you want to remove this section?')) {
      const updated = sections.filter((_, i) => i !== index);
      onChange(updated);
    }
  };

  if (!isEditMode) return null;

  return (
    <>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          position: 'fixed',
          right: '20px',
          top: '100px',
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          background: 'var(--color-primary)',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          zIndex: 1001,
          fontSize: '1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {isExpanded ? '×' : '☰'}
      </button>

      {isExpanded && (
        <div style={{ 
          position: 'fixed', 
          right: '20px', 
          top: '160px', 
          background: 'white', 
          padding: '1rem', 
          borderRadius: '8px', 
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          zIndex: 1000,
          maxWidth: '250px',
          maxHeight: '70vh',
          overflowY: 'auto'
        }}>
          <h3 style={{ margin: '0 0 1rem 0', fontSize: '1rem' }}>Sections</h3>
          {sections.map((section, index) => (
            <div key={section.id} style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '0.5rem', 
              marginBottom: '0.5rem',
              padding: '0.5rem',
              background: '#f5f5f5',
              borderRadius: '4px'
            }}>
              <span style={{ flex: 1, fontSize: '0.9rem' }}>{section.title}</span>
              <button onClick={() => moveSection(index, 'up')} disabled={index === 0} className="btn-small">↑</button>
              <button onClick={() => moveSection(index, 'down')} disabled={index === sections.length - 1} className="btn-small">↓</button>
              {section.type === 'generic' && (
                <button onClick={() => removeSection(index)} className="btn-small" style={{ background: '#c77c7c' }}>×</button>
              )}
            </div>
          ))}
          <button onClick={addSection} className="btn" style={{ width: '100%', marginTop: '1rem' }}>Add Section</button>
        </div>
      )}
    </>
  );
}

export default SectionManager;
